import { call, put, takeEvery } from "redux-saga/effects"
import { GET_BANKS, DELETE_BANK, EDIT_BANK, SAVE_BANKS } from "./actionTypes"
import {
  getBanksSuccess,
  getBanksFail,
  deleteBanksSuccess,
  deleteBanksFail,
  editBankSuccess,
  editBankFail,
  saveBankSuccess,
  saveBankError,
  initData
} from "./actions"
import i18n from "i18next"
import serviceBank from "../../api/bank.service"
import showToast from "../../components/Common/viewNotification"
function* fetchBanks({ payload: filter }) {
  try {
    const response = yield serviceBank.getBanks(filter)
    const error = response?.response?.data?.error
    if (error) {
      yield put(getBanksFail(error))
    } else {
      yield put(getBanksSuccess(response))
    }
  } catch (error) {
    yield put(getBanksFail(error))
  }
}

function* fetchSaveBanks({ payload: bank }) {
  try {
    yield put(initData(null))
    const response = yield call(serviceBank.saveBanks, bank)
    const error = response?.response?.data?.error

    if (error) {
      yield put(saveBankError(error))
    } else {
      yield put(saveBankSuccess(response))
      showToast(i18n.t("global:msgSuccessSaveList"), "success")
    }
  } catch (error) {
    yield put(saveBankError(error))
  }
}
function* onEditBank({ payload: bank }) {
  try {
    yield put(initData(null))
    const response = yield call(serviceBank.editBank, bank)
    const error = response?.response?.data?.error
    if (error) {
      yield put(editBankFail(error))
    } else {
      yield put(editBankSuccess(response))
      showToast(i18n.t("global:msgSuccessSaveList"), "success")
    }
  } catch (error) {
    yield put(editBankFail(error))
  }
}

function* onDeleteBank({ payload: bank }) {
  try {
    yield put(initData(null))
    const response = yield call(serviceBank.deleteBank, bank)
    const error = response?.response?.data?.error
    if (error) {
      yield put(deleteBanksFail(error))
    } else {
      yield put(deleteBanksSuccess(response))
    }
  } catch (error) {
    yield put(deleteBanksFail(error))
  }
}
function* banksSaga() {
  yield takeEvery(GET_BANKS, fetchBanks)
  yield takeEvery(DELETE_BANK, onDeleteBank)
  yield takeEvery(EDIT_BANK, onEditBank)
  yield takeEvery(SAVE_BANKS, fetchSaveBanks)
}

export default banksSaga
